/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

import { Link } from 'react-router-dom'
import Container from './container'

const Footer = () => {
    return (
        <footer className="py-16 border-t-2 border-primary-lighter">
            <Container>
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                    <div className="text-center sm:text-center md:text-center lg:text-left mb-5 sm:mb-5 md:mb-5 lg:mb-0">
                        <div className="header mb-10">
                            <h1 className="text-gray-50 font-semibold text-3xl mb-1.5">StellaNode</h1>
                            <p className="text-sm text-gray-300">Supercharge your hosting experience.</p>
                        </div>
                        <div className="body">
                            {/* <a className="text-gray-200 hover:text-gray-100 hover:underline" href="mailto:support@elysiannode.com">support@stellanode.com</a> */}
                            <p className="text-gray-200 mt-2">&copy; 2020-{(new Date().getFullYear())} | HIUN LLC, All Rights Reserved.</p>
                            <a href="//www.dmca.com/Protection/Status.aspx?ID=de400101-e6c8-45ae-a247-db0f30e0183a" title="DMCA.com Protection Status" className="dmca-badge"> <img src ="https://images.dmca.com/Badges/dmca-badge-w150-5x1-10.png?ID=de400101-e6c8-45ae-a247-db0f30e0183a"  alt="DMCA.com Protection Status" /></a>  <script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"> </script>
                        </div>
                    </div>
                    <div className="text-center">
                        <h1 className="text-gray-100 font-semibold text-2xl mb-3">Services</h1>
                        <ul>
                            <li className="py-0.5">
                                <Link to="/games/minecraft" className="text-gray-200 hover:text-gray-100 hover:underline text-lg">
                                    Minecraft Server
                                </Link>
                            </li>
                            <li className="py-0.5">
                                <Link to="/other/discord" className="text-gray-200 hover:text-gray-100 hover:underline text-lg">
                                    Discord Hosting
                                </Link>
                            </li>
                            <li className="py-0.5">
                                <Link to="/games" className="text-gray-200 hover:text-gray-100 hover:underline text-lg">
                                    All Servers
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="text-center">
                        <h1 className="text-gray-100 font-semibold text-2xl mb-3">Support</h1>
                        <ul>
                            <li className="py-0.5">
                                <a href="https://billing.stellanode.com/submitticket.php" className="text-gray-200 hover:text-gray-100 hover:underline text-lg">Open a Ticket</a>
                            </li>
                            <li className="py-0.5">
                                <a href="https://discord.gg/stellanode" className="text-gray-200 hover:text-gray-100 hover:underline text-lg">Discord Server</a>
                            </li>
                            <li className="py-0.5">
                                <a href="mailto:help@stellanode.com" className="text-gray-200 hover:text-gray-100 hover:underline text-lg">Email Us</a>
                            </li>
                        </ul>
                    </div>
                    <div className="text-center">
                        <h1 className="text-gray-100 font-semibold text-2xl mb-3">Legal</h1>
                        <ul>
                            <li className="py-0.5">
                                <Link to='/terms' className="text-gray-200 hover:text-gray-100 hover:underline text-lg">Terms of Service</Link>
                            </li>
                            <li className="py-0.5">
                                <Link to='/privacy' className="text-gray-200 hover:text-gray-100 hover:underline text-lg">Privacy Policy</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </Container>
        </footer>
    )
}

export default Footer